import { css } from '@emotion/core';
import { colorsPalette } from '../../../../../styles/colors';
import { typography } from '../../../../../styles/typography';
import {
  BEZIER_CURVES,
  ANIMATION_LENGTH,
} from '../../../../../utils/animations';

export const swiperCss = css({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  width: '100%',
  overflowX: 'hidden',

  '.swiper-container': {
    cursor:
      'url(/-/media/regus/images/ui/cursor-slider-image-hover.ashx), url(/-/media/regus/images/ui/cursor-slider-image-hover-cur.cur), move',
    height: '75%',
    marginTop: 30,
    overflow: 'visible',
    width: '100%',
  },

  '.swiper-slide': {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },

  '.grabbed .swiper-slide img': {
    transform: 'scale3d(1.06, 1.06, 1)',
  },

  '.swiper-pagination': {
    height: 15,
    pointerEvents: 'none',
    position: 'fixed',
    textAlign: 'center',
    top: 32,
    zIndex: '1',
    ['span']: {
      lineHeight: '24px',
    },
  },

  '.swiper-lazy-preloader': {
    alignItems: 'center',
    animation: 'none',
    background: colorsPalette.brown10,
    display: 'flex',
    height: '36vmax',
    justifyContent: 'center',
    left: '0',
    margin: '0',
    transform: 'translate3d(0, -50%, 0)',
    transformOrigin: '0%',
    width: '48vmax',
    ':after': {
      display: 'none',
    },
  },
});

export const regusPaginationActiveNumberCss = css(typography.effra14, {
  color: colorsPalette.black,
});

export const regusPaginationDashCss = css(typography.effra14, {
  borderBottom: `1px solid ${colorsPalette.grey60}`,
  color: colorsPalette.grey60,
  display: 'inline-block',
  height: 1,
  margin: '0 8px',
  verticalAlign: 'middle',
  width: 10,
});

export const regusPaginationNumberCss = css(typography.effra14, {
  color: colorsPalette.grey60,
});

const buttonBase = css({
  background: 'transparent',
  border: 0,
  cursor: 'pointer',
  outline: 0,
  padding: 0,
  position: 'fixed',
  top: 37,
  zIndex: '1',
});

export const pictureCss = css({
  alignItems: 'center',
  display: 'flex',
  height: 'auto',
  overflow: 'hidden',
  width: '100%',
});

export const imageCss = css({
  height: 'auto',
  transition: `transform ${ANIMATION_LENGTH._700MS} ${BEZIER_CURVES.FUNCTIONAL}`,
  width: '100%',
});

export const nextButtonCss = css(buttonBase, {
  left: 89,
});

export const prevButtonCss = css(buttonBase, {
  left: 42,
});
